import { Box, Dialog, DialogContent, Grid, MenuItem, Typography, styled } from '@mui/material'
import { icons, imgs } from '../../constants/images'
import ButtonCustom from '../../component/button/buttonCustom'
import { useLocation, useNavigate } from 'react-router-dom';
import { LayoutTitle, LayoutView, TitleText } from '../../component/layout/layoutMainStyle';
import FilterSelect from '../../component/select/filterSelect';
import { useCallback, useEffect, useState } from 'react';
import BoxDoc from '../../component/boxDoc/boxDoc';
import { BoxList, HeadList, ItemList, List, ListGrid } from './searchResultsStyle'
import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import TableCustom from '../../component/table/tableCustom';
import TableRowCommon from '../../component/table/TableRowCommon';
import InputDatePicker from '../../component/input/inputDatePicker';
import moment from 'moment';
import SearchApi from '../../api/search/search.api';
import FolderApi from '../../api/folder/folder.api';
import AutocompleteSelect from '../../component/select/autoCompleteSelect';
import DialogOpenFile from '../documents/dialog/dialogOpenFile';

export default function SearchResults() {
    const navigate = useNavigate();
    const location = useLocation()
    const state = location.state
    const [viewType, setViewType] = useState<string>('column')
    const [sdate, setSdate] = useState<string>('');
    const [edate, setEdate] = useState<string>('');
    const [data, setData] = useState<any>([])
    const [page, setPage] = useState<number>(1);
    const [keywordLevel1, setKeywordLevel1] = useState<string>('');
    const [keywordLevel2, setKeywordLevel2] = useState<string>('');
    const [keywordLevel3, setKeywordLevel3] = useState<string>('');
    const [keywordLevel4, setKeywordLevel4] = useState<string>('');
    const [keywordLevel1v, setKeywordLevel1v] = useState<any>();
    const [keywordLevel2v, setKeywordLevel2v] = useState<any>();
    const [keywordLevel3v, setKeywordLevel3v] = useState<any>();
    const [keywordLevel4v, setKeywordLevel4v] = useState<any>();
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [rowCount, setRowCount] = useState<number>(3);
    const [totalPages, setTotalPages] = useState<number>(3);
    const [totalItem, setTotalItem] = useState<number>(60);
    const [idDocumentType, setIdDocumentType] = useState<number>();
    const [documentType, setDocumentType] = useState<any>([]);
    const [fileLocation, setFileLocation] = useState<string>('');
    const [folderLocation, setFolderLocation] = useState<string>('');
    const [folderName, setFolderName] = useState<any>([]);
    const [openFile, setOpenFile] = useState(false);
    const [file, setFile] = useState<any>();

    useEffect(() => {
        setSdate(state.sdate)
        setEdate(state.edate)
        setPage(1)
        setKeywordLevel1(state.keywordLevel1)
        setKeywordLevel2(state.keywordLevel2)
        setKeywordLevel3(state.keywordLevel3)
        setKeywordLevel4(state.keywordLevel4)
        setKeywordLevel1v(state.keywordLevel1v)
        setKeywordLevel2v(state.keywordLevel2v)
        setKeywordLevel3v(state.keywordLevel3v)
        setKeywordLevel4v(state.keywordLevel4v)
    }, [state])
    const loadData = useCallback(async () => {
        let condition: any = {};
        if (page) condition = { ...condition, page: page };
        if (state.idSearchType) condition = { ...condition, searchType: state.idSearchType };
        if (keywordLevel1) condition = { ...condition, keywordLevel1: keywordLevel1 };
        if (keywordLevel2) condition = { ...condition, keywordLevel2: keywordLevel2 };
        if (keywordLevel3) condition = { ...condition, keywordLevel3: keywordLevel3 };
        if (keywordLevel4) condition = { ...condition, keywordLevel4: keywordLevel4 };
        if (sdate) condition = { ...condition, startDate: sdate };
        if (edate) condition = { ...condition, endDate: edate };
        if (state.keyword) condition = { ...condition, keyword: state.keyword };
        if (state.keywordIndex) condition = { ...condition, keywordIndex: state.keywordIndex };
        // if (state.keywordIndex) condition = { ...condition, keyword: state.keywordIndex };
        if (state.fileLocation) condition = { ...condition, fileLocation: state.fileLocation };
        // if (state.folderLocation) condition = { ...condition, keyword: state.folderLocation };
        if (state.idDocumentType) condition = { ...condition, idDocumentType: state.idDocumentType };

        SearchApi.getSearchAdvance(condition).then((res) => {
            if (res?.data?.success) {
                const { items, meta } = res.data.result;
                setData(items);
                setPage(meta.currentPage)
                setRowCount(meta.totalItems)
                setTotalItem(meta.totalItems)
                setTotalPages(meta.totalPages)
            }
        });
    }, [keywordLevel1, keywordLevel2, keywordLevel3, keywordLevel4, sdate, edate, state, page, pageLimit]);

    const loadFolderName = async () => {
        const res = await FolderApi.getFolderName()
        const data = await res.data;
        if (data?.success) {
            setFolderName(data.result)
        }
    }
    const getDocumentType = async () => {
        const res = await FolderApi.getDocumentType()
        const data = res.data
        if (data?.success) {
            setDocumentType(data.result)
        }
    }
    useEffect(() => {
        loadFolderName()
        getDocumentType()
    }, [])
    useEffect(() => {
        loadData()
    }, [loadData])

    const headCells = [
        {
            id: "#",
            disablePadding: false,
            align: "center",
            colSpan: 1,
            width: '5%'
        },
        {
            id: "name",
            label: 'ชื่อ',
            align: "left",
            colSpan: 1,
            sortable: true,
            width: '30%'
        },
        {
            id: "folderNamePath",
            label: 'ที่อยู่',
            align: "left",
            colSpan: 1,
            sortable: true,
            width: '45%'

        },
        {
            id: "size",
            label: 'ขนาดไฟล์',
            align: "left",
            colSpan: 1,
            sortable: true,
            width: '10%'
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            colSpan: 1,
            width: '30%'
        },
    ];


    const renderData = (objData: any, index: any) => {
        const { name, size, folderNamePath, folderPath, idFile, type } = objData;
        index = page * pageLimit - pageLimit + index + 1;

        const objRenderData = {
            key: index,
            id: index,
            obj: objData,
            columns: [
                {
                    option: "TEXT", align: "left", label:
                        type === 'folder' ? <icons.Folder style={{ marginRight: "12px" }} /> :
                            <icons.file style={{ marginRight: "12px" }} />
                },
                { option: "TEXT", align: "left", label: name },
                { option: "TEXT", align: "left", label: folderNamePath },
                { option: "TEXT", align: "left", label: (size / 1000000).toFixed(2) + ' MB' },

                {
                    option: "COMPONENT",
                    align: "center",
                    component: (

                        <><icons.eyePasswordInput style={{ cursor: 'pointer' }} onClick={() => {
                            if (idFile) {
                                setOpenFile(true)
                                setFile({ idFile: idFile })
                            }
                            else {
                                navigate('/shared-documents', { state: { folderPath: folderPath?.split('/') || [] } })

                            }
                        }
                        } /></>

                    )
                }

            ],

        }


        return (
            <TableRowCommon
                {...objRenderData}
                ondocumentdetail={() => { }}
            />
        )
    };
    return (
        <LayoutView>
            <LayoutTitle>
                <TitleText>ผลการค้นหา “{state.keyword}“</TitleText>
            </LayoutTitle>
            {false ?
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '160px auto' }}>
                    <img src={imgs.myDocumentImage} alt='myDocumentImage' />
                </div>
                :
                <>
                    <Grid container columns={15} sx={{ marginBottom: '12px' }}>
                        <Grid md={2} xs={12} sx={{ marginRight: '10px' }}>

                            <InputDatePicker
                                dateFormat="DD/MM/YYYY"
                                required={false}
                                key={""}
                                disabled={false}
                                label=""
                                value={sdate}
                                onClear={() => setSdate('')}
                                onChange={(e: any) => setSdate(moment(e).format("YYYY-MM-DD"))
                                }
                                allowClear
                                heading={'ตั้งแต่วันที่'} />
                        </Grid>
                        <Grid md={2} xs={12} sx={{ marginRight: '10px' }}>
                            <InputDatePicker
                                dateFormat="DD/MM/YYYY"
                                required={false}
                                key={""}
                                disabled={false}
                                label=""
                                value={edate}
                                onClear={() => setEdate('')}
                                onChange={(e: any) => setEdate(moment(e).format("YYYY-MM-DD"))
                                }
                                allowClear
                                heading={'ถึงวันที่'} />
                        </Grid>
                        <Grid md={2} xs={12} sx={{ marginRight: '10px' }}>
                            <AutocompleteSelect
                                freeSolo
                                options={folderName?.level1}
                                // disabled={location.state.params.isView}
                                getOptionLabel={(option: any) => option}
                                labelId="addmin-type"
                                inputValue={keywordLevel1}
                                value={keywordLevel1v}
                                onChange={(event, newValue) => {
                                    setKeywordLevel1v(newValue)
                                }}
                                heading={'ตู้เอกสาร/หน่วยงาน'}
                                placeholder='ทั้งหมด'
                                onInputChange={(event, newValue) => {
                                    setKeywordLevel1(newValue)
                                }}
                                // required
                                helperText={''}
                            />
                        </Grid>
                        <Grid md={2} xs={12} sx={{ marginRight: '10px' }}>
                            <AutocompleteSelect
                                freeSolo
                                options={folderName?.level2}
                                // disabled={location.state.params.isView}
                                getOptionLabel={(option: any) => option}
                                labelId="addmin-type"
                                inputValue={keywordLevel2}
                                value={keywordLevel2v}
                                onChange={(event, newValue) => {
                                    setKeywordLevel2v(newValue)
                                }}
                                heading={'ชื่อชั้นเอกสาร'}
                                placeholder='ทั้งหมด'
                                onInputChange={(event, newValue) => {
                                    setKeywordLevel2(newValue)
                                }}
                                // required
                                helperText={''}
                            />
                        </Grid>
                        <Grid md={2} xs={12} sx={{ marginRight: '10px' }}>
                            <AutocompleteSelect
                                freeSolo
                                options={folderName?.level3}
                                // disabled={location.state.params.isView}
                                getOptionLabel={(option: any) => option}
                                labelId="addmin-type"
                                inputValue={keywordLevel3}
                                value={keywordLevel3v}
                                onChange={(event, newValue) => {
                                    setKeywordLevel3v(newValue)
                                }}
                                heading={'แฟ้มเอกสาร'}
                                placeholder='ทั้งหมด'
                                onInputChange={(event, newValue) => {
                                    setKeywordLevel3(newValue)
                                }}
                                // required
                                helperText={''}
                            />
                        </Grid>
                        <Grid md={2} xs={12} sx={{ marginRight: '10px' }}>
                            <AutocompleteSelect
                                freeSolo
                                options={folderName?.level4}
                                // disabled={location.state.params.isView}
                                getOptionLabel={(option: any) => option}
                                labelId="addmin-type"
                                inputValue={keywordLevel4}
                                value={keywordLevel4v}
                                onChange={(event, newValue) => {
                                    setKeywordLevel4v(newValue)
                                }}
                                heading={'ชื่อประเภทเอกสาร'}
                                placeholder='ทั้งหมด'
                                onInputChange={(event, newValue) => {
                                    setKeywordLevel4(newValue)
                                }}
                                // required
                                helperText={''}
                            />
                        </Grid>
                        <Grid md={2} xs={12} sx={{ marginRight: '10px' }}>
                            <FilterSelect heading='ปีงบประมาณ' labelId='' selectId='' options={[{ value: 'ทั้งหมด', name: 'ทั้งหมด' },].map((x, i) => {
                                return (
                                    <MenuItem key={i}
                                        value={x.value}
                                    >
                                        {x.name}
                                    </MenuItem>
                                )
                            })} value={'ทั้งหมด'} onchange={(e: any) => { }} />
                        </Grid>
                    </Grid>
                    <div style={{ marginBottom: '12px', display: "flex", justifyContent: 'flex-end' }}>
                        <div style={{ display: "flex" }}>
                            <icons.listFill style={{ cursor: "pointer" }} onClick={() => setViewType('column')} />
                            <icons.bMenu style={{ cursor: "pointer" }} onClick={() => setViewType('box')} />
                        </div>
                    </div>
                    {viewType === 'column' ?
                        <TableCustom
                            headCells={headCells}
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortType={"ASC"}
                            sortBy=""
                            rowCount={rowCount}
                            rowsData={data?.map((d: any, index: any) => {
                                return renderData(d, index);
                            })}
                            onSort={() => { }}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                            totalPages={totalPages}
                            totalItem={totalItem}
                        // hidePagination
                        /> :
                        <Grid container columns={14} spacing={2} sx={{
                        }}>
                            {data.map((x: any, i: number) => {
                                return (
                                    <BoxDoc id={i} onClick={() => navigate('/shared-documents', { state: { folderPath: x?.folderPath?.split('/') || [] } })} icon={x.level === 1 ?
                                        <icons.box1 /> : x.level === 2 ? <icons.box2 /> : x.level === 3 ? <icons.box3 /> : x.level === 4 ? <icons.box3 /> : <icons.box4 />} title={x.name} checkbox dropDown />
                                )
                            })}

                        </Grid>
                    }
                </>}

            <DialogOpenFile
                openFile={openFile}
                setOpenFile={setOpenFile}
                file={file}
                setFile={setFile}
            />
        </LayoutView>
    )
}
